export default "__VITE_ASSET__cae41bcb__"